import heroImg from '../assets/hero-img.png'
import rightUp from '../assets/arrow-right-up.png'
import triAngle from '../assets/tri-angle.png'
import longW from '../assets/long-w.png'
import circle from '../assets/circle.png'
import plus from '../assets/add.png'
import { motion } from 'framer-motion';

const Hero = () => {
    return (
        <motion.div 
            className="flex tab:flex-col justify-between pt-32 px-8 tab:px-4"
            variants={{
                hidden: { opacity: 0, y: 75 },
                visible: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5, delay: 0.3 }}
            initial="hidden"
            animate="visible"
        >

            <motion.div 
                className="w-1/2 tab:w-full tab:mb-10"
                variants={{
                    hidden: { opacity: 0, x: -75 },
                    visible: { opacity: 1, x: 0},
                }}
                transition={{ duration: 0.7, delay: 0.7,  type: 'spring', stiffness: 300  }}
                initial = "hidden"
                animate = "visible"
            >
                <h1 className='text-white text-5xl font-bold'>
                    Build Your Awesome Platform
                </h1>
                <p className='text-greys text-lg py-7 pr-5 tab:pr-0'>
                    Enver studio is a digital studio that offers several services such as UI/UX Design to developers, we will provide the best service for those of you who use our services.
                </p>

                <button className='flex items-center gap-2 bg-blue text-lg text-white font-semibold py-2 px-5 rounded-sm cursor-pointer'>
                    Our Services
                    <img 
                        src={rightUp} 
                        alt="Right Arrow" 
                        className='w-5'
                    />
                </button>

            </motion.div>

            <div className='relative flex tab:items-center tab:justify-center justify-end -mt-20 tab:mt-0 z-0'>
                <img 
                    src={heroImg}
                    alt="Hero Img" 
                    className='max-w-full w-[470px]'
                />

                <img 
                    src={longW}
                    alt="Hero Img" 
                    className='absolute top-20 left-0 w-16'
                />
                <img 
                    src={circle}
                    alt="Hero Img" 
                    className='absolute top-16 right-0 w-10'
                />
                <img 
                    src={plus}
                    alt="Hero Img" 
                    className='absolute bottom-10 right-0 w-10'
                />
                <img 
                    src={triAngle}
                    alt="Hero Img" 
                    className='absolute bottom-10 left-0 w-16'
                />
            </div>

        </motion.div>
    );
}
 
export default Hero;